import React from 'react'
import styled from 'styled-components'
import { Flex } from '../styles/styled-common'

const Div = styled.div`
  font-size: 0.9em;
`
const HostProp = ({ label, semicolon, children }) => (
  <Flex justifyContent="space-between">
    <div>{label ? `${label}${semicolon ? ': ' : ''}` : ''}</div>
    <Div>{children}</Div>
  </Flex>
)

export default HostProp



// WEBPACK FOOTER //
// /opt/build/repo/src/components/PropItem.jsx